interface CharacterCounterProps {
  currentLength: number;
  maxLength: number;
  warningThreshold?: number; // Default: 90% of maxLength
  className?: string;
}

export function CharacterCounter({
  currentLength,
  maxLength,
  warningThreshold,
  className = "",
}: CharacterCounterProps) {
  const threshold = warningThreshold ?? Math.floor(maxLength * 0.9);
  const isOverLimit = currentLength > maxLength;
  const isNearLimit = currentLength >= threshold && currentLength <= maxLength;

  let textColor = "text-theme-muted";
  if (isOverLimit) {
    textColor = "text-semantic-error font-semibold";
  } else if (isNearLimit) {
    textColor = "text-semantic-warning font-medium";
  }

  return (
    <div
      className={`text-sm ${textColor} ${className}`}
      role="status"
      aria-live="polite"
      aria-atomic="true"
    >
      {/* eslint-disable no-restricted-syntax */}
      {currentLength.toLocaleString()} / {maxLength.toLocaleString()} characters
      {isOverLimit && <span className="ml-2 text-semantic-error">
        (over limit by {(currentLength - maxLength).toLocaleString()})
      </span>}
      {/* eslint-enable no-restricted-syntax */}
    </div>
  );
}
